import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Edit your photo`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/77567e9139e6ca689104871306a9db6e/SX_ImageResize_44_N.svg",
                "alt": "Resize image"
              }}></img><p>{`Resize image`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/31466adf1b58b6dc4663a313b65134d2/SX_Convert_44_N.svg",
                "alt": "Convert to SVG"
              }}></img><p>{`Convert to SVG`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/beeee0a951eef8f5968dac1f8a6a30c0/SX_RemoveBackground_44_N.svg",
                "alt": "Remove background"
              }}></img><p>{`Remove background`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/a100ed6cf30e2b75b440ba3cd5ecdbb2/SX_ImageCrop_44_N.svg",
                "alt": "Crop image"
              }}></img><p>{`Crop image`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/31466adf1b58b6dc4663a313b65134d2/SX_Convert_44_N.svg",
                "alt": "Convert to JPG"
              }}></img><p>{`Convert to JPG`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/d6c1747e7a15cf1e83a16f9f44a6d26a/SX_QRCode_44_N.svg",
                "alt": "Generate QR COode"
              }}></img><p>{`Generate QR code`}</p>{` `}</div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/31466adf1b58b6dc4663a313b65134d2/SX_Convert_44_N.svg",
                "alt": "Convert to PNG"
              }}></img><p>{`Convert to PNG`}</p>{` `}</div></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      